import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MulebuySpreadsheetGuide from "../pages/article/guide/page";
import HowMulebuySpreadsheetWorks from "../pages/article/how-works/page";
import BestVerifiedList from "../pages/article/best-verified-list/page";
import MulebuySpreadsheetExplained from "../pages/article/explained/page";
import IsMulebuySpreadsheetSafe from "../pages/article/is-safe/page";
import MulebuyVsHoobuy from "../pages/article/vs-hoobuy/page";
import TopHiddenGems from "../pages/article/hidden-gems/page";
import SaveMoneyGuide from "../pages/article/save-money/page";
import BestSneakersGuide from "../pages/article/best-sneakers/page";
import CompleteShoppingGuide from "../pages/article/complete-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mulebuy-spreadsheet-guide",
    element: <MulebuySpreadsheetGuide />,
  },
  {
    path: "/how-mulebuy-spreadsheet-works",
    element: <HowMulebuySpreadsheetWorks />,
  },
  {
    path: "/best-verified-mulebuy-spreadsheet-list",
    element: <BestVerifiedList />,
  },
  {
    path: "/mulebuy-spreadsheet-explained",
    element: <MulebuySpreadsheetExplained />,
  },
  {
    path: "/is-mulebuy-spreadsheet-safe",
    element: <IsMulebuySpreadsheetSafe />,
  },
  {
    path: "/mulebuy-vs-hoobuy-spreadsheet",
    element: <MulebuyVsHoobuy />,
  },
  {
    path: "/top-hidden-gems-mulebuy-spreadsheet",
    element: <TopHiddenGems />,
  },
  {
    path: "/save-money-mulebuy-spreadsheet",
    element: <SaveMoneyGuide />,
  },
  {
    path: "/best-sneakers-mulebuy-spreadsheet",
    element: <BestSneakersGuide />,
  },
  {
    path: "/complete-mulebuy-shopping-guide",
    element: <CompleteShoppingGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;